import {ajaxRest} from './ajaxBase'

const CONTROLLER_PREFIX = 'authentication'
const RESTFUL_API_VER = 'v1.0'

// function login (user, pwd, tokenTs) {
//   let p = new Promise((resolve, reject) => {
//     let params = {
//       url: `/${RESTFUL_API_VER}/${CONTROLLER_PREFIX}/login`,
//       method: 'POST',
//       data: {
//         userName: user,
//         password: pwd,
//         tokenTs: tokenTs
//       },
//       timeout: {client: 10 * 1000}
//     }

//     ajaxRest(params).then(data => {
//       resolve(data)
//     }).catch(error => {
//       reject(error)
//     })
//   })
//   return p
// }

function refreshToken () {
  let p = new Promise((resolve, reject) => {
    let params = {
      url: `/login/refresh`,
      method: 'POST',
      timeout: {client: 10 * 1000}
    }

    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function logout () {
  let p = new Promise((resolve, reject) => {
    let params = {
      url: `/login/logout`,
      method: 'POST',
      timeout: {client: 10 * 1000}
    }

    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function checkToken (token) {
  let p = new Promise((resolve, reject) => {
    let params = {
      url: `/${RESTFUL_API_VER}/${CONTROLLER_PREFIX}/check/token`,
      method: 'POST',
      data: {
        token: token
      },
      timeout: {client: 10 * 1000}
    }

    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function getVerCode (param) {
  let p = new Promise((resolve, reject) => {
    let params = {
      url: `/${RESTFUL_API_VER}/${CONTROLLER_PREFIX}/code/sms`,
      method: 'POST',
      data: {
        phone: param
      },
      timeout: {client: 10 * 1000}
    }

    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function loginWithPwd (username, pwd, type, tokenTs, optionData) {
  let inputData = {
    username: username,
    password: pwd,
    type: type,
    tokenTs: tokenTs
  }
  if (optionData) {
    inputData = { ...inputData, ...optionData };
  }

  let p = new Promise((resolve, reject) => {
    let params = {
      url: `/login`,
      method: 'POST',
      data: inputData,
      timeout: {client: 30 * 1000}
    }

    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function resetPassword (username) {
  let p = new Promise((resolve, reject) => {
    let params = {
      url: `/login/resetpassword`,
      method: 'POST',
      data: {
        username: username
      },
      timeout: {client: 10 * 1000}
    }

    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

export default {
  loginWithPwd,
  refreshToken,
  logout,
  checkToken,
  getVerCode,
  resetPassword
}



// WEBPACK FOOTER //
// ./src/api/authAPI.js